import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from 'context/AuthContext';
import { useRequestListagem } from 'hooks/useRequestListagem';

export type Permission = {
    idPermissao: number;
    dsChavePermissao: string;
    dsPermissao: string;
};

export function useQueryPermissions() {
    const { stopTokenRenewal } = useAuthContext();
    const requestListagem = useRequestListagem();

    return useQuery<Permission[]>({
        queryKey: ['permissions'],
        queryFn: () => requestListagem({ url: '/security/permissao/grupousuario' }).then((data) => data.data.data),
        onSuccess: (data) => {
            if (!data.length) stopTokenRenewal();
        },
        onError: stopTokenRenewal,
    });
}
